<template>
  <div class="position-relative overflow-auto">
    <transition name="fade-copy">
      <div v-if="showCopy" class="green-copy"
           @touchstart="touchStart"
           @touchmove="touchMove"
           @touchend="touchEnd"
           :style="{ transform: `translate(${offsetX}px, ${offsetY}px)` }">
        {{ $t('Ссылка скопирована') }}
      </div>
    </transition>
    <div class="d-flex btn-group justify-center ga-6">
      <ShareKit :link-to-copy="link" :title="name" :before-share="handleBeforeShare" :file="sharedFile">
        <div class="btn-item">
          <v-progress-circular indeterminate size="18" :width="2" color="primary" bg-color="transparent" v-if="isLoading"/>
          <ShareIcon class="icon" color="#8D959D" v-else></ShareIcon>
          <div class="two-lines">
            {{ $t('Поделиться ссылкой') }}
          </div>
        </div>
      </ShareKit>
      <div class="btn-item flex-1-1-0" @click="copy">
        <copy-link class="icon"></copy-link>
        <div>
          {{ $t('Копировать') }}
        </div>
      </div>
    </div>
    <div>
      <QRView :link="link" :alias="alias" :image="image" :name="name"
              :q-color="qrStore.settings.color"
              :b-color="qrStore.settings.backgroundColor"
              :q-image="qrStore.settings.imageFileBase64 || qrStore.KTIcon"
              ref="QRViewRef"/>
    </div>
    <v-btn variant="outlined" color="accent" rounded="lg" @click="downloadPNG" class="mt-2 w-100"><v-icon :icon="DownloadIcon" color="BW-500" size="24" class="mr-2"/>PNG</v-btn>
  </div>
</template>

<script setup lang="ts">

import CopyLink from "~/assets/icons/copy-link.vue";
import ShareIcon from "~/assets/icons/share.vue";
import {computed, onMounted, ref} from "vue";
import QRView from "@/components/dialogs/QRView.vue";
import DownloadIcon from "~/assets/icons/download.vue";
import {useQrSettingsStore} from "@/stores/qrSettingsStore";

const props = defineProps({
  alias: { type: String },
  name: { type: String },
  image: { type: String },
  lang: { type: String },
  defaultLang: { type: String },
});

const qrStore = useQrSettingsStore()

const config = useRuntimeConfig()
const host = config.public.tapLink;
const showCopy = ref(false)

let startX = 0
let startY = 0
const offsetX = ref(0)
const offsetY = ref(0)


function touchStart(e: TouchEvent) {
  const t = e.touches[0]
  startX = t.clientX
  startY = t.clientY
}

function touchMove(e: TouchEvent) {
  const t = e.touches[0]
  offsetX.value = t.clientX - startX
  offsetY.value = t.clientY - startY
}

function touchEnd() {
  if (Math.abs(offsetX.value) > 30 || Math.abs(offsetY.value) > 30) {
    showCopy.value = false
  }

  offsetX.value = 0
  offsetY.value = 0
}

const copy = () => {
  navigator.clipboard.writeText(`https://${host}/${props.alias}/${props.lang}`)
  showCopy.value = true

  setTimeout(() => {
    showCopy.value = false
  }, 1500)
}

const link = ref('')
onMounted(async() => {
  await qrStore.fetchSettings(props.alias);
  link.value = `https://${host}/${props.alias}${props.defaultLang != props.lang ? '/' + props.lang : ''}`
})

const QRViewRef = ref(null);
const downloadPNG = () => {
  QRViewRef.value?.downloadPNG()
}

const handleBeforeShare = async () => {
  if (QRViewRef.value) {
    await QRViewRef.value.initFile();
  }
}

const sharedFile = computed(() => QRViewRef.value?.shareFile);
const isLoading = computed(() => QRViewRef.value?.shareInProgress || false);
</script>

<style scoped lang="sass">
.btn-group
  padding: 12px 8px
  margin: 0 8px
  .btn-item
    cursor: pointer
    font-size: 12px
    display: flex
    flex-direction: column
    align-items: center
    gap: 9px
    color: #363636
    line-height: normal

    .icon
      padding: 8px
      background: #F6F7F8
      border-radius: 50px
      width: 40px
      height: 40px
      svg
        width: 24px
        height: 24px

.green-copy
  position: absolute
  top: 0
  left: 0
  background: #05A660D9
  width: 100%
  padding: 8px 16px
  border-radius: 8px
  color: #fff
  font-weight: 500

.fade-copy-enter-active
  transition: opacity 0.1s ease

.fade-copy-leave-active
  transition: opacity 0.2s ease

.fade-copy-enter-from,
.fade-copy-leave-to
  opacity: 0
</style>
